var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: 24.286,
    viewBox: "0 0 17 24.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gesture-double-tap_1_",
    "data-name": "gesture-double-tap (1)",
    d: "M11.071,10.286a1.214,1.214,0,0,1,2.429,0v5.428l1.469.158,6,2.659A1.779,1.779,0,0,1,22,20.17v5.294a1.885,1.885,0,0,1-1.821,1.821H12.286a1.644,1.644,0,0,1-1.214-.522l-5.95-5.1.9-.935a1.2,1.2,0,0,1,.9-.389h.267l3.886,2.089V10.286m1.214-4.857a4.857,4.857,0,0,1,4.857,4.857,4.8,4.8,0,0,1-2.429,4.2V13.006a3.643,3.643,0,1,0-4.857,0v1.481a4.8,4.8,0,0,1-2.429-4.2,4.857,4.857,0,0,1,4.857-4.857m0-2.429a7.291,7.291,0,0,1,5.051,12.544L16.123,15a6.078,6.078,0,1,0-6.266.85v1.311A7.288,7.288,0,0,1,12.286,3Z",
    transform: "translate(-5 -3)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsIcon);
export default __webpack_public_path__ + "static/media/actions-icon.981b7fb97b5ef46b23daf71302a7ba72.svg";
export { ForwardRef as ReactComponent };